import { call, put } from 'redux-saga/effects'
import { apiConfig } from '../../../../../config/api-config'
import { makeAccess } from '../../../../../config/factory-controller'
import { ResetPasswordRepository } from '../../../data/repositories/reset-password-repository'
import type { ResetPasswordRequest } from '../../../domain/models/reset-password'
import { ResetPasswordService } from '../../../service/reset-password-service'
import { ResetPasswordController } from '../../controllers/reset-password-controller'
import * as action from '../actions/reset-password-actions'

export const controller = async (payload: ResetPasswordRequest) => {
  const { key, token } = await makeAccess()
  const dataSource = new ResetPasswordService(apiConfig(key, token))
  const repository = new ResetPasswordRepository(dataSource)
  const control = new ResetPasswordController(repository)
  return await control.reset(payload)
}

export function* resetPasswordSaga({ payload }: any): any {
  try {
    const result = yield call(controller, payload)
    yield put(action.resetPasswordSuccess(result))
  } catch (error: any) {
    yield put(action.resetPasswordError(error.toString()))
  }
}
